import { DateTimeField } from "@mui/x-date-pickers/DateTimeField";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, blueMui, redMui, rydeColors } from "@ryde/theme";

export const DateEditableTemplateWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "data-editable-cell-wrapper",
})`
  color: ${blueGreyMui._500};
  display: flex;
  align-items: center;
`;

export const DataEditableStyledButton = styled.button.attrs<IStyledAttributes>({
  "data-e2e": "data-editable-styled-button",
})`
  font-family: inherit;
  font-size: 14px;
  border-radius: 2px;
  text-align: center;
  padding: 5px;
  border: 1px solid ${blueMui._300};
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  background-color: ${rydeColors.white};
  &.error {
    background-color: ${redMui.A400};
    border-color: ${redMui.A400};
    color: ${rydeColors.white};
  }
`;

export const DataEditableButtonContentStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "data-editable-template",
  },
)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const DateTimeFieldStyled = styled(DateTimeField)`
  .MuiInputBase-root {
    font-size: 14px;

    &:hover,
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${blueMui._300};
      }
    }
  }

  .MuiInputBase-input {
    padding-inline-start: 5px;
    padding-block: 5px;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: ${blueMui._300};
    border-radius: 2px;
  }
`;

export const RideStartEndDateEditableTemplateStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "ride-start-end-datetime-template",
  },
)`
  display: flex;
  align-items: center;
`;

RideStartEndDateEditableTemplateStyled.displayName =
  "RideStartEndDateEditableTemplateStyled";
